import { find } from "lodash";
import { FC, Fragment, useState } from "react";
import {
  Button,
  Confirm,
  useRefresh,
  useNotify,
  useUnselectAll,
  useDataProvider,
  BulkActionProps,
} from "react-admin";

const BulkDeleteAdhocOperatorButton: FC<BulkActionProps> = ({
  selectedIds,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const provider = useDataProvider();

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    setLoading(true);

    Promise.all(
      selectedIds.map(async (idToDelete) => {
        try {
          await provider.delete("adhocOperators", {
            id: idToDelete,
            previousData: null,
          });
          return { success: true, id: idToDelete };
        } catch (error) {
          return { success: false, id: idToDelete };
        }
      }),
    ).then((result: any) => {
      if (find(result, { success: false })) {
        notify("Some item(s) cannot be deleted");
      } else {
        notify("Item(s) deleted");
        unselectAll("adhocOperators");
      }
      setLoading(false);
      refresh();
    });

    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label="Delete"
        onClick={handleClick}
        style={{ backgroundColor: "#f44336" }}
      />
      <Confirm
        isOpen={open}
        loading={loading}
        title="Delete item(s)"
        content={`Are you sure you want to delete for these items?`}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </Fragment>
  );
};

export default BulkDeleteAdhocOperatorButton;
